<template>
  <el-dialog
    :visible.sync="changePasswordVisibless"
    width="20%"
    :before-close="handlePasswordClose"
    :append-to-body="true"
    class="dialog-xiu">
    <div class="password">
      <span class="title-xiu">修改密码</span>
      <el-form class="form" :model="passwordForm" ref="passwordForm" :rules="dataRule" label-width="100px">
        <!-- <el-form-item label="原密码：" prop="oldPassword">
          <el-input type="text" autocomplete="off" placeholder="请输入原密码" v-model="passwordForm.oldPassword"/>
        </el-form-item> -->

        <el-form-item label="新密码：" prop="newPassword">
          <el-input type="text" autocomplete="off" placeholder="请输入新密码" v-model="passwordForm.newPassword"/>
        </el-form-item>

        <el-form-item label="确认密码：" prop="confirmPassword">
          <el-input type="text" autocomplete="off" placeholder="请输入确认密码" v-model="passwordForm.confirmPassword"/>
        </el-form-item>

        <el-button type="primary" class="submit-s" style="margin-left: 10px;" @click="updatePassword">
          <span style="font-size: 18px;">修改</span>
        </el-button>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'changePassword',

  props:{
    changePasswordVisible: {
      type: Boolean,
      default: false
    },
  },

  data() {
      //校验密码
      let validPwd = (rule, value, callback) => {
        if (this.passwordForm.newPassword == this.passwordForm.confirmPassword) {
          callback();
        } else {
          callback(new Error("两次输入密码不一致"))
        }
      };
    return {
      changePasswordVisibless: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      },

      dataRule: {
        // oldPassword: [
        //   { required: true, message: '原密码不能为空', trigger: 'blur' }
        // ],
        newPassword: [
          { required: true, message: '新密码不能为空', trigger: 'blur' }
        ],
        confirmPassword:[
          { required: true, trigger: 'blur', validator: validPwd }
        ]
      },
    }
  },

  watch:{
    changePasswordVisible(){
      this.changePasswordVisibless = this.changePasswordVisible;
    },
  },

  mounted() {
  },

  methods: {
    ...mapActions([
      'UpdateForget',
    ]),


    //关闭弹窗
    handlePasswordClose() {
      this.changePasswordVisibless = false;
      this.$emit('handlePasswordClose')
    },

    //修改密码
    updatePassword() {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          let appMemberUserUpdatePasswordReqVO = {
            password: this.passwordForm.confirmPassword,
            code: '1234'
          }
          this.UpdateForget(appMemberUserUpdatePasswordReqVO)
            .then((res) => {
              console.log(res)
              if (res.code == 0) {
                location.href = '/';
              }
            })
            .catch(() => {
            });
        } else {
          return false;
        }
      });
    },
  }
}
</script>

<style  lang="less">
  .dialog-xiu {
    height: 100%;
    overflow: hidden;
  }

  .dialog-xiu .el-dialog {
    height: 45%;
    min-height: 438px;
    min-width: 600px;
    overflow: hidden;
    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 40px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
    }
  }

  /deep/.el-dialog__body {
    height: 70vh;
    overflow: auto;
  }

  .password{
    margin-left: 20px;
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items:center;
    text-align:center;
    line-height:100px;
  }

  .title-xiu {
    font-size: 24px;
  }

  .password .el-input__inner {
    height: 40px;
    width: 300px;
  }


  .submit-s {
    margin-top: 10px;
    color: white;
    background: linear-gradient(44deg,#346cf4,#539fff);;
    width: 100%;
    border-radius: 4px;
    border-width: 0;
    cursor: pointer;
    font-size: 16px;
    height: 49px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/user/changePassword.vue